import { MessageCircle, FileText, ArrowRight } from 'lucide-react';


/**
 * IntegrationsSection Component
 * 
 * Showcases external integrations like WhatsApp (current) and Alegra (upcoming).
 */
function IntegrationsSection() {
    return (
        <section className="integrations-section relative py-24 bg-gray-950 overflow-hidden" id="integrations">
            {/* Background elements */}
            <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>
            <div className="absolute left-1/2 top-0 -translate-x-1/2 w-[1000px] h-[500px] bg-emerald-900/10 rounded-[100%] blur-[120px] pointer-events-none"></div>

            <div className="max-w-[1280px] mx-auto px-8 relative z-10">
                <div className="text-center mb-16">
                    <div className="inline-block px-4 py-2 rounded-full border border-teal-500/30 bg-teal-500/10 text-teal-400 font-bold text-xs uppercase tracking-widest mb-6">
                        Conectividad Total
                    </div>
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                        Conectado con tus herramientas favoritas
                    </h2>
                    <p className="text-xl text-gray-400 max-w-2xl mx-auto">
                        Automatiza tus procesos usando las plataformas en las que ya confías.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                    {/* WhatsApp */}
                    <div className="glass-card rounded-2xl p-8 hover-lift border border-green-500/20 group">
                        <div className="w-16 h-16 rounded-2xl bg-green-500/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                            <MessageCircle className="text-green-400" size={32} />
                        </div>
                        <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                            WhatsApp Business
                            <span className="text-xs font-bold px-2 py-1 bg-green-500/20 text-green-400 rounded-md">Incluido</span>
                        </h3>
                        <p className="text-gray-400 leading-relaxed mb-6">
                            Reduce el ausentismo automatizando mensajes. Cresta envía de forma nativa recordatorios
                            de citas, felicitaciones de cumpleaños y mensajes de recuperación totalmente integrados.
                        </p>
                        <ul className="space-y-3 text-gray-300">
                            <li className="flex items-center gap-2">
                                <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div> Recordatorios automáticos 24h antes
                            </li>
                            <li className="flex items-center gap-2">
                                <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div> Links de reserva directa
                            </li>
                        </ul>
                    </div>

                    {/* Alegra */}
                    <div className="glass-card rounded-2xl p-8 hover-lift border border-blue-500/20 group relative overflow-hidden">
                        {/* Shimmer effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-[100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                        
                        <div className="w-16 h-16 rounded-2xl bg-blue-500/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                            <FileText className="text-blue-400" size={32} />
                        </div>
                        <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                            Facturación Electrónica DIAN
                            <span className="text-xs font-bold px-2 py-1 bg-teal-500/20 text-teal-400 rounded-md whitespace-nowrap border border-teal-500/30">Próximamente</span>
                        </h3>
                        <p className="text-gray-400 leading-relaxed mb-6">
                            Simplifica tu contabilidad integrando directamente el sistema líder regional. 
                            Cada servicio finalizado en Cresta podrá automatizar la emisión de tu facturación electrónica.
                        </p>
                        <div className="flex items-center justify-between p-4 rounded-xl bg-gray-900/50 border border-gray-800">
                            <div className="flex items-center gap-4">
                                <span className="text-sm font-medium text-gray-300">Con el respaldo y confianza de</span>
                                <div className="font-bold text-xl tracking-tight" style={{ color: '#00d5a3' }}>Alegra</div>
                            </div>
                            <a 
                                href="https://www.alegra.com/colombia/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-xs font-bold text-teal-400 hover:text-teal-300 flex items-center gap-1 transition-colors"
                            >
                                Conoce Alegra
                                <ArrowRight size={14} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default IntegrationsSection;
